var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "page-outline",
    {
      attrs: {
        title:
          _vm.store == 0
            ? _vm.$t("common.security.add_p12", { itemLabel: "truststore" })
            : _vm.$t("common.security.add_p12", { itemLabel: "keystore" }),
      },
    },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                { staticClass: "justify-content-start mb-5" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "4", sm: "3", md: "2", xl: "1" } },
                    [
                      _c("back-button", {
                        attrs: { returnUrl: _vm.returnUrl },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "form-accordion",
                {
                  attrs: {
                    title: _vm.$t("common.security.p12"),
                    isTitleUpperCase: false,
                  },
                },
                [
                  _c("div", { staticClass: "form-group" }, [
                    _c("input", {
                      ref: "fileInputP12",
                      attrs: { type: "file", accept: ".p12" },
                      on: { change: _vm.onFileChange },
                    }),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.certificateInfo
                ? _c("hr", { staticClass: "mx-auto mb-4" })
                : _vm._e(),
              _vm._v(" "),
              _vm.certificateInfo
                ? _c(
                    "form-accordion",
                    {
                      attrs: {
                        title: _vm.$t("common.security.keystore"),
                        isTitleUpperCase: false,
                      },
                    },
                    [
                      _c(
                        "b-row",
                        {
                          staticClass:
                            "d-flex justify-content-start form-group",
                        },
                        [
                          _c(
                            "b-col",
                            { staticClass: "form-group", attrs: { sm: "2" } },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { value: 1, "unchecked-value": 0 },
                                  model: {
                                    value: _vm.form.keystore.state,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form.keystore, "state", $$v)
                                    },
                                    expression: "form.keystore.state",
                                  },
                                },
                                [
                                  _c("span", { staticClass: "text-break" }, [
                                    _vm._v(
                                      _vm._s(_vm.form.keystore.nameDisplay)
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "form-group mb-5",
                              attrs: { sm: "2" },
                            },
                            [
                              _c("form-write-group-label-input", {
                                attrs: {
                                  isMandatory: "",
                                  inputLabel: _vm.$t("common.security.name"),
                                  placeholderValue: _vm.$t(
                                    "common.security.name"
                                  ),
                                },
                                model: {
                                  value: _vm.form.keystore.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form.keystore, "name", $$v)
                                  },
                                  expression: "form.keystore.name",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "form-group mb-5",
                              attrs: { sm: "2" },
                            },
                            [
                              _c("form-write-group-label-input", {
                                attrs: {
                                  inputLabel: _vm.$t(
                                    "common.security.password"
                                  ),
                                  placeholderValue: _vm.$t(
                                    "common.security.password"
                                  ),
                                },
                                model: {
                                  value: _vm.form.keystore.password,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form.keystore, "password", $$v)
                                  },
                                  expression: "form.keystore.password",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "form-group mb-5",
                              attrs: { sm: "2" },
                            },
                            [
                              _c("form-read-group-label-input", {
                                attrs: {
                                  inputValue: _vm.form.keystore.startDate,
                                  inputLabel: _vm.$t(
                                    "common.security.startDate"
                                  ),
                                  placeholderValue: _vm.$t(
                                    "common.security.startDate"
                                  ),
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "form-group mb-5",
                              attrs: { sm: "2" },
                            },
                            [
                              _c("form-read-group-label-input", {
                                attrs: {
                                  inputValue: _vm.form.keystore.endDate,
                                  inputLabel: _vm.$t("common.security.endDate"),
                                  placeholderValue: _vm.$t(
                                    "common.security.endDate"
                                  ),
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "form-group mb-5",
                              attrs: { sm: "2" },
                            },
                            [
                              _c("form-read-group-label-input", {
                                attrs: {
                                  inputValue: _vm.form.keystore.deliveredBy,
                                  inputLabel: _vm.$t(
                                    "common.security.deliveredBy"
                                  ),
                                  placeholderValue: _vm.$t(
                                    "common.security.deliveredBy"
                                  ),
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("b-col", {
                            staticClass: "form-group mb-5",
                            attrs: { sm: "2" },
                          }),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "form-group mb-5",
                              attrs: { sm: "2" },
                            },
                            [
                              _c("form-read-group-label-input", {
                                attrs: {
                                  inputValue: _vm.form.keystore.deliveredTo,
                                  inputLabel: _vm.$t(
                                    "common.security.deliveredTo"
                                  ),
                                  placeholderValue: _vm.$t(
                                    "common.security.deliveredTo"
                                  ),
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mt-3 justify-content-end form-group" },
                        [
                          _vm.form.keystore.state
                            ? _c(
                                "b-col",
                                { attrs: { cols: "4", lg: "2", xl: "2" } },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { variant: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.createKeystore()
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-light fa-save",
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "common.security.add_keystore"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "b-col",
                                { attrs: { cols: "4", lg: "2", xl: "2" } },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        variant: "primary",
                                        disabled: "",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-light fa-save",
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "common.security.add_keystore"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.certificateInfo
                ? _c("hr", { staticClass: "mx-auto mb-4" })
                : _vm._e(),
              _vm._v(" "),
              _vm.certificateInfo
                ? _c(
                    "form-accordion",
                    {
                      attrs: {
                        title: _vm.$t("common.security.truststore"),
                        isTitleUpperCase: false,
                      },
                    },
                    [
                      _vm._l(_vm.form.truststore, function (certifcat, index) {
                        return _c(
                          "b-row",
                          {
                            key: index,
                            staticClass: "d-flex align-items-center form-group",
                          },
                          [
                            _c(
                              "b-col",
                              {
                                staticClass: "form-group mb-5",
                                attrs: { sm: "2" },
                              },
                              [
                                _c(
                                  "b-form-checkbox",
                                  {
                                    attrs: { value: 1, "unchecked-value": 0 },
                                    model: {
                                      value: certifcat.state,
                                      callback: function ($$v) {
                                        _vm.$set(certifcat, "state", $$v)
                                      },
                                      expression: "certifcat.state",
                                    },
                                  },
                                  [
                                    _c("span", { staticClass: "text-break" }, [
                                      _vm._v(_vm._s(certifcat.nameDisplay)),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticClass: "form-group mb-5",
                                attrs: { sm: "2" },
                              },
                              [
                                _c("form-write-group-label-input", {
                                  attrs: {
                                    isMandatory: "",
                                    inputLabel: _vm.$t("common.security.name"),
                                    placeholderValue: _vm.$t(
                                      "common.security.name"
                                    ),
                                  },
                                  model: {
                                    value: certifcat.name,
                                    callback: function ($$v) {
                                      _vm.$set(certifcat, "name", $$v)
                                    },
                                    expression: "certifcat.name",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticClass: "form-group mb-5",
                                attrs: { sm: "2" },
                              },
                              [
                                _c("form-read-group-label-input", {
                                  attrs: {
                                    inputValue: certifcat.startDate,
                                    inputLabel: _vm.$t(
                                      "common.security.startDate"
                                    ),
                                    placeholderValue: _vm.$t(
                                      "common.security.startDate"
                                    ),
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticClass: "form-group mb-5",
                                attrs: { sm: "2" },
                              },
                              [
                                _c("form-read-group-label-input", {
                                  attrs: {
                                    inputValue: certifcat.endDate,
                                    inputLabel: _vm.$t(
                                      "common.security.endDate"
                                    ),
                                    placeholderValue: _vm.$t(
                                      "common.security.endDate"
                                    ),
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticClass: "form-group mb-5",
                                attrs: { sm: "2" },
                              },
                              [
                                _c("form-read-group-label-input", {
                                  attrs: {
                                    inputValue: certifcat.deliveredBy,
                                    inputLabel: _vm.$t(
                                      "common.security.deliveredBy"
                                    ),
                                    placeholderValue: _vm.$t(
                                      "common.security.deliveredBy"
                                    ),
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticClass: "form-group mb-5",
                                attrs: { sm: "2" },
                              },
                              [
                                _c("form-read-group-label-input", {
                                  attrs: {
                                    inputValue: certifcat.deliveredTo,
                                    inputLabel: _vm.$t(
                                      "common.security.deliveredTo"
                                    ),
                                    placeholderValue: _vm.$t(
                                      "common.security.deliveredTo"
                                    ),
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mt-3 justify-content-end" },
                        [
                          _vm.canSaveTrustStore
                            ? _c(
                                "b-col",
                                { attrs: { cols: "6", lg: "3", xl: "2" } },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { variant: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.showModal("create")
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-light fa-save",
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "common.security.link_truststore"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "b-col",
                                { attrs: { cols: "6", lg: "3", xl: "2" } },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        variant: "primary",
                                        disabled: "",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-light fa-save",
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "common.security.link_truststore"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                          _vm._v(" "),
                          _vm.canSaveTrustStore
                            ? _c(
                                "b-col",
                                { attrs: { cols: "6", lg: "3", xl: "2" } },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "ml-2",
                                      attrs: { variant: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.showModal("link")
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-light fa-save",
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "common.security.create_truststore"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "b-col",
                                { attrs: { cols: "6", lg: "3", xl: "2" } },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "ml-2",
                                      attrs: {
                                        variant: "primary",
                                        disabled: "",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-light fa-save",
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "common.security.create_truststore"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showModalElement
                ? _c("security-pop-up", {
                    attrs: { caList: _vm.caListPopUp },
                    on: { close: _vm.close, savepopup: _vm.createTruststore },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }